<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <vx-tooltip v-if="params.data.statusComment" :text="params.data.statusComment">
        <span>{{ status(params.value) }}</span>
     </vx-tooltip>
     
     <span v-if="!params.data.statusComment">{{ status(params.value) }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  data() {
    return {
      index:0,
    }
  },
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'Approved' ) return 'success'
        else if (value === 'Rejected') return 'danger'
        else return 'primary'
      }
    },
    status () {
      return (value) => {
        if (value === 'Approved') return 'Approved'
        else if(value === 'Rejected') return 'Rejected'
        else return 'Pending'
      }
    }
  },
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
